// optimizelyHelper expects an optimizely config like so:
// const optimizelyConfig = {
//   // Staging
//   554664308: {
//     pageName: '554664308_url_targeting_for_perfect_registry_onboarding',
//     experimentId: '12109791999',
//     variationId: '12091993637'
//   },
//   // Production
//   566520915: {
//     pageName: '566520915_url_targeting_for_perfect_registry_onboarding',
//     experimentId: '12115484653',
//     variationId: '12119022586'
//   }
// };

export default function inOptimizelyExperiment(optimizelyConfig) {
  if (window.optimizely && window.optimizely.get) {
    const optimizelyData = window.optimizely.get('data');
    const {
      pageName,
      experimentId,
      variationId
    } = optimizelyConfig[optimizelyData.projectId];

    window.optimizely = window.optimizely || [];
    window.optimizely.push({
      type: 'page',
      pageName
    });

    const state = window.optimizely.get('state');
    const allExperiments = state.getExperimentStates({ isActive: true });
    const experiment = allExperiments[experimentId];

    if (experiment && experiment.variation && experiment.variation.id === variationId) {
      return true;
    }
  }

  return false;
}



// WEBPACK FOOTER //
// ./src/util/optimizelyHelper.js